// extracted by mini-css-extract-plugin
module.exports = {"trust-list-item":"trust-list-item-a039a24e3a23c71c31a0623430570401","content":"content-080f8ab3e1702238c558bdbcd20d4bc6"};